import { createSlice } from '@reduxjs/toolkit';
import { AppMyBusinessPages } from '../../components/AppMyBusiness/AppMyBusiness.model';

interface IMyBusinessSlice {
	activeMyBusinessPage: AppMyBusinessPages;
	shopItemPageVisible: boolean;
}

const initialState: IMyBusinessSlice = {
	activeMyBusinessPage: AppMyBusinessPages.Main,
	shopItemPageVisible: false,
};

const myBusinessSlice = createSlice({
	name: 'myBusiness',
	initialState,
	reducers: {
		setMyBusinessActivePage: (state, action) => {
			state.activeMyBusinessPage = action.payload;
		},
		setMyBusinessShopItemPageVisible: (state, action) => {
			state.shopItemPageVisible = action.payload;
		},
		resetMyBusinessSlice: () => ({ ...initialState }),
	},
});

export const {
	setMyBusinessActivePage,
	setMyBusinessShopItemPageVisible,
	resetMyBusinessSlice,
} = myBusinessSlice.actions;

export default myBusinessSlice.reducer;
